import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "footer__sub" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 order-2 text-center col-md-auto order-md-0 text-md-start" }
const _hoisted_5 = { class: "col-12 order-1 d-md-none" }
const _hoisted_6 = { class: "col-12 order-md-2 col-md-auto" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]


export default /*@__PURE__*/_defineComponent({
  __name: 'FooterSub',
  props: {
  items: {
    type: Array,
    required: true,
  },
},
  setup(__props) {



const openUC = (): void => {
  if (window.UC_UI) {
    window.UC_UI.showSecondLayer();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_BaseSpacer = _resolveComponent("BaseSpacer")!
  const _component_IoRouterLink = _resolveComponent("IoRouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, " © " + _toDisplayString(new Date().format('Y')) + " STADTWERK AM SEE GmbH & Co. KG ", 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_BaseSpacer, { class: "d-md-none" })
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "d-none order-1 d-md-block col-md" }, null, -1)),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("nav", null, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (menuItem) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: `mifs-${menuItem.id}`
                }, [
                  (menuItem.url === '#cookie-einstellungen')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        innerHTML: menuItem.title,
                        onClick: openUC
                      }, null, 8, _hoisted_7))
                    : (_openBlock(), _createBlock(_component_IoRouterLink, {
                        key: 1,
                        "link-url": menuItem.url,
                        "link-target": menuItem.target,
                        "link-title": menuItem.titleAttr,
                        id: `iomi-${ menuItem.id }`,
                        active: menuItem.active
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            innerHTML: menuItem.title
                          }, null, 8, _hoisted_8)
                        ]),
                        _: 2
                      }, 1032, ["link-url", "link-target", "link-title", "id", "active"]))
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})